exports.IDS = {
  // IMG_URL: "http://127.0.0.1:4326",
  // IMG_URL: "https://navsiddhi.node.profcyma.org:4326",
  // IMG_URL: "https://newnode.secureestate.in:5856",
  IMG_URL: "https://newnode.secureestate.in",

  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",    
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  users: {
    admin: 1,
    builder: 2,
    customer: 3,
  },

  usersrole: {
    admin: "Admin",
    builder: "Builder",
    customer: "Customer",
  },

  legal_verification_status: {
    process: 1,
    approved: 2,
    rejected: 3,
  },
};
